import { Fragment, useState } from "react";
import Header from "../component/layout/header";
import Footer from "../component/layout/footer";
import "../page/Singing/AdvertisementPage.css";
import Swal from "sweetalert2";

const AdvertisementPage = () => {
const [formData, setFormData] = useState({
  name: "",
  email: "",
  phone: "",
  plan: "",
  message: "",
});

const [errors, setErrors] = useState({});

const handleChange = (e) => {
  const { name, value } = e.target;

  setFormData({
    ...formData,
    [name]: value,
  });

  // remove error while typing
  setErrors({
    ...errors,
    [name]: "",
  });
};
const validateForm = () => {
  let newErrors = {};

  // Name validation
  if (!formData.name.trim()) {
    newErrors.name = "Full name is required";
  } else if (formData.name.length < 3) {
    newErrors.name = "Name must be at least 3 characters";
  }

  // Email validation
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!formData.email) {
    newErrors.email = "Email is required";
  } else if (!emailRegex.test(formData.email)) {
    newErrors.email = "Enter valid email";
  }

  // Phone validation (10 digits)
  const phoneRegex = /^[0-9]{10}$/;
  if (!formData.phone) {
    newErrors.phone = "Phone number is required";
  } else if (!phoneRegex.test(formData.phone)) {
    newErrors.phone = "Enter valid 10 digit phone number";
  }

  // Plan validation
  if (!formData.plan) {
    newErrors.plan = "Please select a plan";
  }

  // Message validation
  if (formData.message && formData.message.length < 10) {
    newErrors.message = "Message must be at least 10 characters";
  }

  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
};


const handleSubmit = async (e) => {
  e.preventDefault();

  if (!validateForm()) return;

  Swal.fire({
    title: "Submitting...",
    allowOutsideClick: false,
    didOpen: () => Swal.showLoading(),
  });

  try {
    const res = await fetch(
      "https://kalakakshaaha.com/kks/api/v1/ads-request",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      }
    );

    const data = await res.json();

    Swal.close();

if (data.success) {
  Swal.fire({
    icon: "success",
    title: "Request Submitted",
    text: "Our team will contact you shortly.",
    confirmButtonColor: "#ff7a00",
  });

  // ✅ CLEAR FORM DATA
  setFormData({
    name: "",
    email: "",
    phone: "",
    plan: "",
    message: "",
  });

  // ✅ CLEAR ERRORS ALSO
  setErrors({});
}
 else {
      Swal.fire("Error", data.message, "error");
    }
  } catch {
    Swal.fire("Error", "Server error", "error");
  }

  
};





  return (
    <Fragment>
      <Header />

      <section className="ads-section">
        <div className="ads-container">

          {/* PAGE HEADER */}
          <h2 className="ads-title">Advertise With Us</h2>
          <p className="ads-subtitle">
            Promote your brand and reach a highly engaged audience across our platform.
          </p>

          <div className="ads-grid">

            {/* LEFT — ADVERTISEMENT PLANS */}
            <div className="ads-plans">

              {/* HOME PAGE PLAN */}
              <div className="ads-card">
                <h3 className="ads-card-title">Home Page Advertisement</h3>

                <p className="price">₹4,899 / month</p>

                <ul className="ads-features">
                  <li>Premium banner placement on homepage</li>
                  <li>Maximum visibility to platform visitors</li>
                  <li>High engagement and reach</li>
                </ul>

                <div className="offer-box">
                  Special Offer: Pay for one month and receive two additional months at no extra cost.
                </div>
              </div>

              {/* CATEGORY PLAN */}
              <div className="ads-card">
                <h3 className="ads-card-title">Category Page Advertisement</h3>

                <div className="pricing-list">
                  <p><strong>Country Level:</strong> ₹3,899</p>
                  <p><strong>State Level:</strong> ₹2,899</p>
                  <p><strong>City Level:</strong> ₹1,899</p>
                </div>

                <ul className="ads-features">
                  <li>Location-based targeted promotion</li>
                  <li>Focused audience engagement</li>
                  <li>Improved conversion opportunities</li>
                </ul>
              </div>

            </div>

            {/* RIGHT — BOOKING FORM */}
<div className="ads-form-box">
  <h4 className="form-title">Request Advertisement</h4>

  <form onSubmit={handleSubmit}>

    <input
      name="name"
      placeholder="Full Name"
      value={formData.name}
      onChange={handleChange}
    />
    {errors.name && <p className="error">{errors.name}</p>}

    <input
      name="email"
      placeholder="Email Address"
      value={formData.email}
      onChange={handleChange}
    />
    {errors.email && <p className="error">{errors.email}</p>}

   <input
  name="phone"
  placeholder="Phone Number"
  value={formData.phone}
  maxLength="10"
  onChange={(e) => {
    const value = e.target.value.replace(/[^0-9]/g, ""); // allow only digits
    setFormData({ ...formData, phone: value });

    setErrors({ ...errors, phone: "" });
  }}
/>

    {errors.phone && <p className="error">{errors.phone}</p>}
<select name="plan" value={formData.plan} onChange={handleChange}>
  <option value="">Select Advertisement Plan</option>
  <option value="home_page">Home Page Advertisement</option>
  <option value="country_category">Country Category Advertisement</option>
  <option value="state_category">State Category Advertisement</option>
  <option value="city_category">City Category Advertisement</option>
</select>

    {errors.plan && <p className="error">{errors.plan}</p>}

    <textarea
      name="message"
      placeholder="Provide details about your advertisement requirements"
      value={formData.message}
      onChange={handleChange}
    />
    {errors.message && <p className="error">{errors.message}</p>}

    <button type="submit" className="submit-btnn">
      Submit Request
    </button>

  </form>
</div>


          </div>
        </div>
      </section>

      <Footer />
    </Fragment>
  );
};

export default AdvertisementPage;
